import { SearchProvider } from '@cast/shared-search-ui';
import { DateRangeFilter } from '@cast/shared-date-ui';
import { useCluster } from '@cast/shared-cluster-context-data-access';
import { Box } from '@cast/design-system';
import { reliabilityFilterPresets } from '@cast/split-me/features/cost-report';
import {
  ReliabilityCostReportProvider,
  ReliabilityWorkloadsSection,
  useReliabilityWorkloads,
  useWorkloadsSearchCriteria,
  WorkloadFilters,
} from '@cast/split-me/features/cluster/cost-report';

import { WORKLOAD_CATEGORIES, WORKLOAD_VIEWS } from '../../../_constants';
import { inventoryWorkloadsTableKeys, tableCacheKeys } from '../../../consts';
import { buildInventoryWorkloadViewPath } from '../../../navigation';

const ReliabilityContent = () => {
  const criteria = useWorkloadsSearchCriteria();
  const { cluster } = useCluster();

  const getWorkloadLink = (workload: { id: string }) =>
    buildInventoryWorkloadViewPath({
      clusterId: cluster.id,
      workloadId: workload.id,
      category: WORKLOAD_CATEGORIES.RELIABILITY,
      view: WORKLOAD_VIEWS.DASHBOARD,
    });

  return (
    <SearchProvider
      criteria={criteria}
      useData={useReliabilityWorkloads}
      urlKey={inventoryWorkloadsTableKeys.RELIABILITY}
      serverSideSort
      disableFreeText
    >
      <Box mb={15}>
        <WorkloadFilters size="small" />
      </Box>
      <ReliabilityWorkloadsSection
        cacheKey={tableCacheKeys.INVENTORY_WORKLOADS.RELIABILITY}
        getWorkloadLink={getWorkloadLink}
      />
    </SearchProvider>
  );
};

export const InventoryWorkloadsListReliability = () => (
  <ReliabilityCostReportProvider
    rangePickerProps={{
      filterPresets: reliabilityFilterPresets,
      initialPreset: DateRangeFilter.ThisMonth,
    }}
  >
    <ReliabilityContent />
  </ReliabilityCostReportProvider>
);
